import { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import {
  Users,
  Edit,
  Trash2,
  Eye,
  Search,
  RefreshCw,
  AlertTriangle,
  X,
  Save,
  AlertCircle,
  UserPlus,
  Truck,
  CreditCard,
  Award,
  Plus,
} from "lucide-react";
import Swal from "sweetalert2";

const ListarConductores = () => {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [conductores, setConductores] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [activeTab, setActiveTab] = useState("lista"); // "lista" | "registrar" | "asignar"
  const [showRegistrarCarreta, setShowRegistrarCarreta] = useState(false);
  const [nuevaCarreta, setNuevaCarreta] = useState({
    placa: "",
    marca: "",
    año: "",
  });
  const [showAsignarModal, setShowAsignarModal] = useState(false);
  const [asignarData, setAsignarData] = useState({
    vehiculo_id: "",
    carreta_id: "",
  });
  const [vehiculos, setVehiculos] = useState([]);
  const [carretas, setCarretas] = useState([]);

  // Estados para modal Ver/Editar
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState("view"); // "view" | "edit"
  const [selectedConductor, setSelectedConductor] = useState(null);
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});

  // Estados para formulario de registro
  const [registroData, setRegistroData] = useState({
    dni: "",
    nombre: "",
    apellidos: "",
    telefono: "",
    email: "",
    licencia_numero: "",
    licencia_categoria: "B-IIc",
    licencia_vencimiento: "",
  });
  const [registroErrors, setRegistroErrors] = useState({});

  const API_LARAVEL_URL =
    process.env.REACT_APP_API_URL || "http://localhost:8000/api";

  const getApiHeaders = () => {
    const token = localStorage.getItem("token");
    return {
      "Content-Type": "application/json",
      Accept: "application/json",
      ...(token && { Authorization: `Bearer ${token}` }),
    };
  };

  useEffect(() => {
    if (user?.empresa_id && activeTab === "lista") {
      loadConductores();
    }
  }, [user, activeTab]);

  const loadConductores = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_LARAVEL_URL}/flota/conductores`, {
        headers: getApiHeaders(),
      });

      if (response.ok) {
        const data = await response.json();
        setConductores(data);
      }
    } catch (error) {
      console.error("Error cargando conductores:", error);
      Swal.fire("Error", "No se pudieron cargar los conductores", "error");
    } finally {
      setLoading(false);
    }
  };
  const handleRegistrarCarreta = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_LARAVEL_URL}/flota/carretas`, {
        method: "POST",
        headers: getApiHeaders(),
        body: JSON.stringify({
          placa: nuevaCarreta.placa,
          marca: nuevaCarreta.marca,
          año: nuevaCarreta.año,
          tipo_vehiculo: "CARRETA",
          estado: "ACTIVO",
        }),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        // Agregar a la lista local y preseleccionar
        const carretaNueva = data.data;
        setCarretas((prev) => [...prev, carretaNueva]);
        setAsignarData((prev) => ({ ...prev, carreta_id: carretaNueva.id }));
        setShowRegistrarCarreta(false);
        setNuevaCarreta({ placa: "", marca: "", año: "" });

        Swal.fire({
          icon: "success",
          title: "Registrado",
          text: `Semirremolque ${carretaNueva.placa} registrado y preseleccionado.`,
          timer: 2000,
          showConfirmButton: false,
        });
      } else {
        throw new Error(data.message || "Error al registrar");
      }
    } catch (error) {
      Swal.fire("Error", error.message, "error");
    } finally {
      setLoading(false);
    }
  };
  const handleView = (conductor) => {
    setSelectedConductor(conductor);
    setFormData(conductor);
    setModalMode("view");
    setShowModal(true);
  };

  const handleEdit = (conductor) => {
    setSelectedConductor(conductor);
    setFormData(conductor);
    setModalMode("edit");
    setShowModal(true);
    setErrors({});
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedConductor(null);
    setFormData({});
    setErrors({});
  };
  // Cargar vehículos y carretas al abrir modal
  // const handleAsignarVehiculos = async (conductor) => {
  //   setSelectedConductor(conductor);
  //   setAsignarData({
  //     vehiculo_id: conductor.vehiculo_id || "",
  //     carreta_id: conductor.carreta_id || "",
  //   });

  //   // Cargar catálogos si no están cargados
  //   if (vehiculos.length === 0) {
  //     const [resV, resC] = await Promise.all([
  //       fetch(`${API_LARAVEL_URL}/catalogos/vehiculos`, {
  //         headers: getApiHeaders(),
  //       }),
  //       fetch(`${API_LARAVEL_URL}/catalogos/carretas`, {
  //         headers: getApiHeaders(),
  //       }),
  //     ]);
  //     setVehiculos(await resV.json());
  //     setCarretas(await resC.json());
  //   }

  //   setShowAsignarModal(true);
  // };
  const handleAsignarVehiculos = async (conductor) => {
    setSelectedConductor(conductor);
    setAsignarData({
      vehiculo_id: conductor.vehiculo_id || "",
      carreta_id: conductor.carreta_id || "",
    });

    // ✅ Siempre recargar, no solo cuando está vacío
    try {
  const [resV, resC] = await Promise.all([
        fetch(`${API_LARAVEL_URL}/flota/vehiculos`, {
          // ← cambiar catalogos → flota
          headers: getApiHeaders(),
        }),
        fetch(`${API_LARAVEL_URL}/flota/carretas`, {
          // ← cambiar catalogos → flota
          headers: getApiHeaders(),
        }),
      ]);
      setVehiculos(await resV.json());
      setCarretas(await resC.json());
    } catch (error) {
      console.error("Error cargando catálogos:", error);
      // Dejar las listas vacías para que aparezca el input de texto
    }

    setShowAsignarModal(true);
  };
  const handleGuardarAsignacion = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `${API_LARAVEL_URL}/flota/conductores/${selectedConductor.id}/vehiculos`,
        {
          method: "PUT",
          headers: getApiHeaders(),
          body: JSON.stringify(asignarData),
        },
      );
      const data = await response.json();
      if (response.ok && data.success) {
        Swal.fire("¡Asignado!", data.message, "success");
        setShowAsignarModal(false);
        loadConductores();
      } else {
        throw new Error(data.message);
      }
    } catch (error) {
      Swal.fire("Error", error.message, "error");
    } finally {
      setLoading(false);
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: null,
      }));
    }
  };

  const handleRegistroChange = (e) => {
    const { name, value } = e.target;
    setRegistroData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (registroErrors[name]) {
      setRegistroErrors((prev) => ({
        ...prev,
        [name]: null,
      }));
    }
  };

  const handleSaveEdit = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `${API_LARAVEL_URL}/flota/conductores/${selectedConductor.id}`,
        {
          method: "PUT",
          headers: getApiHeaders(),
          body: JSON.stringify(formData),
        },
      );

      const data = await response.json();

      if (response.ok && data.success) {
        Swal.fire({
          icon: "success",
          title: "¡Actualizado!",
          text: data.message || "Conductor actualizado correctamente",
        });
        handleCloseModal();
        loadConductores();
      } else {
        if (data.errors) {
          setErrors(data.errors);
        } else {
          throw new Error(data.message || "Error al actualizar");
        }
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "No se pudo actualizar el conductor",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleRegistrar = async (e) => {
    e.preventDefault();
    setRegistroErrors({});
    setLoading(true);

    try {
      const response = await fetch(`${API_LARAVEL_URL}/flota/conductores`, {
        method: "POST",
        headers: getApiHeaders(),
        body: JSON.stringify(registroData),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        Swal.fire({
          icon: "success",
          title: "¡Registrado!",
          text: data.message || "Conductor registrado correctamente",
        });
        setRegistroData({
          dni: "",
          nombre: "",
          apellidos: "",
          telefono: "",
          email: "",
          licencia_numero: "",
          licencia_categoria: "B-IIc",
          licencia_vencimiento: "",
        });
        setActiveTab("lista");
      } else {
        if (data.errors) {
          setRegistroErrors(data.errors);
        } else {
          throw new Error(data.message || "Error al registrar");
        }
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "No se pudo registrar el conductor",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleDesasignar = async (conductor) => {
    const result = await Swal.fire({
      title: "¿Desasignar conductor?",
      text: `¿Deseas desasignar a ${conductor.nombre} ${conductor.apellidos} de tu empresa?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Sí, desasignar",
      cancelButtonText: "Cancelar",
    });

    if (result.isConfirmed) {
      try {
        const response = await fetch(
          `${API_LARAVEL_URL}/flota/conductores/${conductor.id}`,
          {
            method: "DELETE",
            headers: getApiHeaders(),
          },
        );

        const data = await response.json();

        if (response.ok && data.success) {
          Swal.fire(
            "Desasignado",
            data.message || "Conductor desasignado correctamente",
            "success",
          );
          loadConductores();
        } else {
          throw new Error(data.message || "Error al desasignar");
        }
      } catch (error) {
        Swal.fire(
          "Error",
          error.message || "No se pudo desasignar el conductor",
          "error",
        );
      }
    }
  };

  const filteredConductores = conductores.filter(
    (c) =>
      (c.dni || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
      (c.nombre || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
      (c.apellidos || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
      (c.telefono || "").toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const getLicenciaColor = (vencimiento) => {
    if (!vencimiento) return "text-gray-500";
    const dias = Math.floor(
      (new Date(vencimiento) - new Date()) / (1000 * 60 * 60 * 24),
    );
    if (dias < 0) return "text-red-600"; // Vencida
    if (dias <= 30) return "text-yellow-600"; // Por vencer
    return "text-green-600"; // Vigente
  };
  // Formatear fecha para mostrar solo YYYY-MM-DD
  const formatFecha = (fechaString) => {
    if (!fechaString) return "-";
    // Extraer solo la parte de la fecha (antes de la T o espacio)
    return fechaString.split("T")[0].split(" ")[0];
  };
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-blue-50 to-indigo-100">
      {/* Header */}
      <div className="bg-white shadow-sm border-b border-gray-200 mb-4">
        <div className="px-4 py-3">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <div className="bg-gradient-to-r from-purple-500 to-pink-600 p-2 rounded-lg mr-3">
                <Users className="h-5 w-5 text-white" />
              </div>
              <div>
                <h1 className="text-xl font-bold text-gray-900">
                  Gestión de Choferes
                </h1>
                <p className="text-sm text-gray-600">
                  Administra los conductores de tu empresa
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div className="px-4 mb-4">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-1 flex space-x-1">
          <button
            onClick={() => setActiveTab("lista")}
            className={`flex-1 px-4 py-2 rounded-lg font-medium transition-colors text-sm flex items-center justify-center ${activeTab === "lista"
                ? "bg-purple-600 text-white shadow-md"
                : "text-gray-600 hover:bg-gray-100"
              }`}
          >
            <Users className="h-4 w-4 mr-2" />
            Lista de Choferes
          </button>
          <button
            onClick={() => setActiveTab("registrar")}
            className={`flex-1 px-4 py-2 rounded-lg font-medium transition-colors text-sm flex items-center justify-center ${activeTab === "registrar"
                ? "bg-emerald-600 text-white shadow-md"
                : "text-gray-600 hover:bg-gray-100"
              }`}
          >
            <UserPlus className="h-4 w-4 mr-2" />
            Registrar Chofer
          </button>
          <button
            onClick={() => setActiveTab("asignar")}
            className={`flex-1 px-4 py-2 rounded-lg font-medium transition-colors text-sm flex items-center justify-center ${activeTab === "asignar"
                ? "bg-blue-600 text-white shadow-md"
                : "text-gray-600 hover:bg-gray-100"
              }`}
          >
            <UserPlus className="h-4 w-4 mr-2" />
            Asignar Existente
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="px-4">
        {/* Tab: Lista de Choferes */}
        {activeTab === "lista" && (
          <>
            {/* Filtros */}
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-4">
              <div className="flex flex-col sm:flex-row gap-3">
                <div className="flex-1 relative">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
                  <input
                    type="text"
                    placeholder="Buscar por DNI, nombre, apellido o teléfono..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 text-sm"
                  />
                </div>
                <button
                  onClick={loadConductores}
                  className="px-4 py-2 text-purple-700 bg-purple-100 hover:bg-purple-200 rounded-lg font-medium transition-colors text-sm flex items-center"
                >
                  <RefreshCw className="w-4 h-4 mr-2" />
                  Recargar
                </button>
              </div>
            </div>

            {/* Tabla */}
            {loading ? (
              <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-12 text-center">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-600 mx-auto mb-4"></div>
                <p className="text-gray-600">Cargando conductores...</p>
              </div>
            ) : (
              <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
                <div className="overflow-x-auto">
                  <table className="w-full text-sm">
                    <thead className="bg-gray-50 border-b border-gray-200">
                      <tr>
                        <th className="px-4 py-3 text-left font-medium text-gray-700">
                          DNI
                        </th>
                        <th className="px-4 py-3 text-left font-medium text-gray-700">
                          Nombre Completo
                        </th>
                        <th className="px-4 py-3 text-left font-medium text-gray-700">
                          Teléfono
                        </th>
                        <th className="px-4 py-3 text-left font-medium text-gray-700">
                          Licencia
                        </th>
                        <th className="px-4 py-3 text-center font-medium text-gray-700">
                          Vencimiento
                        </th>
                        <th className="px-4 py-3 text-center font-medium text-gray-700">
                          Estado
                        </th>
                        <th className="px-4 py-3 text-center font-medium text-gray-700">
                          Acciones
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200">
                      {filteredConductores.length > 0 ? (
                        filteredConductores.map((conductor) => (
                          <tr
                            key={conductor.id}
                            className="hover:bg-gray-50 transition-colors"
                          >
                            <td className="px-4 py-3">
                              <div className="flex items-center">
                                <CreditCard className="h-4 w-4 text-purple-500 mr-2" />
                                <span className="font-medium text-gray-900">
                                  {conductor.dni}
                                </span>
                              </div>
                            </td>
                            <td className="px-4 py-3 text-gray-700">
                              {conductor.nombre} {conductor.apellidos}
                            </td>
                            <td className="px-4 py-3 text-gray-600 text-xs">
                              {conductor.telefono || "-"}
                            </td>
                            <td className="px-4 py-3">
                              <div className="flex items-center">
                                <Award className="h-4 w-4 text-blue-500 mr-1" />
                                <span className="text-gray-700">
                                  {conductor.licencia_categoria}
                                </span>
                              </div>
                            </td>
                            <td className="px-4 py-3 text-center">
                              <span
                                className={`text-xs font-medium ${getLicenciaColor(
                                  conductor.licencia_vencimiento,
                                )}`}
                              >
                                {formatFecha(conductor.licencia_vencimiento)}
                              </span>
                            </td>
                            <td className="px-4 py-3 text-center">
                              <span
                                className={`px-2 py-1 rounded-full text-xs font-medium ${conductor.activo
                                    ? "bg-green-100 text-green-800"
                                    : "bg-red-100 text-red-800"
                                  }`}
                              >
                                {conductor.activo ? "Activo" : "Inactivo"}
                              </span>
                            </td>
                            <td className="px-4 py-3">
                              <div className="flex items-center justify-center space-x-2">
                                <button
                                  onClick={() => handleView(conductor)}
                                  className="p-1 text-blue-600 hover:bg-blue-100 rounded transition-colors"
                                  title="Ver detalles"
                                >
                                  <Eye className="h-4 w-4" />
                                </button>
                                <button
                                  onClick={() => handleEdit(conductor)}
                                  className="p-1 text-emerald-600 hover:bg-emerald-100 rounded transition-colors"
                                  title="Editar"
                                >
                                  <Edit className="h-4 w-4" />
                                </button>
                                <button
                                  onClick={() => handleDesasignar(conductor)}
                                  className="p-1 text-red-600 hover:bg-red-100 rounded transition-colors"
                                  title="Desasignar"
                                >
                                  <Trash2 className="h-4 w-4" />
                                </button>
                                <button
                                  onClick={() =>
                                    handleAsignarVehiculos(conductor)
                                  }
                                  className="p-1 text-orange-600 hover:bg-orange-100 rounded transition-colors"
                                  title="Asignar vehículos"
                                >
                                  <Truck className="h-4 w-4" />
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="7" className="px-4 py-8 text-center">
                            <AlertTriangle className="h-12 w-12 text-gray-300 mx-auto mb-2" />
                            <p className="text-gray-500">
                              {searchTerm
                                ? "No se encontraron conductores"
                                : "No hay conductores asignados"}
                            </p>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </>
        )}

        {/* Tab: Registrar Chofer */}
        {activeTab === "registrar" && (
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 max-w-4xl mx-auto">
            <div className="flex items-center mb-6">
              <div className="bg-gradient-to-r from-emerald-500 to-teal-600 p-2 rounded-lg mr-3">
                <UserPlus className="h-5 w-5 text-white" />
              </div>
              <div>
                <h2 className="text-lg font-bold text-gray-900">
                  Registrar Nuevo Chofer
                </h2>
                <p className="text-sm text-gray-600">
                  Completa los datos del conductor
                </p>
              </div>
            </div>

            <form onSubmit={handleRegistrar} className="space-y-6">
              {/* Datos Personales */}
              <div>
                <h3 className="text-md font-semibold text-gray-700 mb-3 flex items-center">
                  <CreditCard className="h-4 w-4 mr-2" />
                  Datos Personales
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label htmlFor="reg_dni" className="block text-sm font-medium text-gray-700 mb-1">
                      DNI <span className="text-red-500">*</span>
                    </label>
                    <input
                      id="reg_dni"
                      type="text"
                      name="dni"
                      value={registroData.dni}
                      onChange={handleRegistroChange}
                      placeholder="12345678"
                      className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-emerald-500 ${registroErrors.dni
                          ? "border-red-500"
                          : "border-gray-300"
                        }`}
                      required
                    />
                    {registroErrors.dni && (
                      <p className="text-red-500 text-xs mt-1 flex items-center">
                        <AlertCircle className="h-3 w-3 mr-1" />
                        {registroErrors.dni[0]}
                      </p>
                    )}
                  </div>

                  <div>
                    <label htmlFor="reg_nombre" className="block text-sm font-medium text-gray-700 mb-1">
                      Nombre <span className="text-red-500">*</span>
                    </label>
                    <input
                      id="reg_nombre"
                      type="text"
                      name="nombre"
                      value={registroData.nombre}
                      onChange={handleRegistroChange}
                      placeholder="Juan"
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500"
                      required
                    />
                  </div>

                  <div>
                    <label htmlFor="reg_apellidos" className="block text-sm font-medium text-gray-700 mb-1">
                      Apellidos <span className="text-red-500">*</span>
                    </label>
                    <input
                      id="reg_apellidos"
                      type="text"
                      name="apellidos"
                      value={registroData.apellidos}
                      onChange={handleRegistroChange}
                      placeholder="Pérez García"
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500"
                      required
                    />
                  </div>

                  <div>
                    <label htmlFor="reg_telefono" className="block text-sm font-medium text-gray-700 mb-1">
                      Teléfono
                    </label>
                    <input
                      id="reg_telefono"
                      type="tel"
                      name="telefono"
                      value={registroData.telefono}
                      onChange={handleRegistroChange}
                      placeholder="987654321"
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500"
                    />
                  </div>

                  <div className="md:col-span-2">
                    <label htmlFor="reg_email" className="block text-sm font-medium text-gray-700 mb-1">
                      Email
                    </label>
                    <input
                      id="reg_email"
                      type="email"
                      name="email"
                      value={registroData.email}
                      onChange={handleRegistroChange}
                      placeholder="conductor@ejemplo.com"
                      className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-emerald-500 ${registroErrors.email
                          ? "border-red-500"
                          : "border-gray-300"
                        }`}
                    />
                    {registroErrors.email && (
                      <p className="text-red-500 text-xs mt-1">
                        {registroErrors.email[0]}
                      </p>
                    )}
                  </div>
                </div>
              </div>

              {/* Datos de Licencia */}
              <div>
                <h3 className="text-md font-semibold text-gray-700 mb-3 flex items-center">
                  <Award className="h-4 w-4 mr-2" />
                  Licencia de Conducir
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div>
                    <label htmlFor="reg_licencia_numero" className="block text-sm font-medium text-gray-700 mb-1">
                      Número de Licencia
                    </label>
                    <input
                      id="reg_licencia_numero"
                      type="text"
                      name="licencia_numero"
                      value={registroData.licencia_numero}
                      onChange={handleRegistroChange}
                      placeholder="Q12345678"
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500"
                    />
                  </div>

                  <div>
                    <label htmlFor="reg_licencia_categoria" className="block text-sm font-medium text-gray-700 mb-1">
                      Categoría <span className="text-red-500">*</span>
                    </label>
                    <select
                      id="reg_licencia_categoria"
                      name="licencia_categoria"
                      value={registroData.licencia_categoria}
                      onChange={handleRegistroChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500"
                      required
                    >
                      <option value="A-I">A-I - Moto hasta 125cc</option>
                      <option value="A-IIa">A-IIa - Moto 125-250cc</option>
                      <option value="A-IIb">A-IIb - Moto +250cc</option>
                      <option value="A-III">A-III - Mototaxi</option>
                      <option value="B-I">B-I - Auto/Camioneta</option>
                      <option value="B-IIa">B-IIa - Camión hasta 7.5t</option>
                      <option value="B-IIb">B-IIb - Camión 7.5-15t</option>
                      <option value="B-IIc">B-IIc - Camión +15t</option>
                      <option value="B-III">B-III - Ómnibus</option>
                    </select>
                  </div>

                  <div>
                    <label htmlFor="reg_licencia_vencimiento" className="block text-sm font-medium text-gray-700 mb-1">
                      Fecha de Vencimiento
                    </label>
                    <input
                      id="reg_licencia_vencimiento"
                      type="date"
                      name="licencia_vencimiento"
                      value={registroData.licencia_vencimiento}
                      onChange={handleRegistroChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500"
                    />
                  </div>
                </div>
              </div>

              {/* Botones */}
              <div className="flex justify-end space-x-3 pt-4 border-t border-gray-200">
                <button
                  type="button"
                  onClick={() =>
                    setRegistroData({
                      dni: "",
                      nombre: "",
                      apellidos: "",
                      telefono: "",
                      email: "",
                      licencia_numero: "",
                      licencia_categoria: "B-IIc",
                      licencia_vencimiento: "",
                    })
                  }
                  className="px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg font-medium transition-colors"
                >
                  <X className="w-4 h-4 mr-2 inline" />
                  Limpiar
                </button>
                <button
                  type="submit"
                  disabled={loading}
                  className="px-6 py-2 text-white bg-gradient-to-r from-emerald-500 to-teal-600 hover:from-emerald-600 hover:to-teal-700 rounded-lg font-medium transition-all duration-200 flex items-center shadow-lg hover:shadow-xl disabled:opacity-50"
                >
                  {loading ? (
                    <>
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                      Guardando...
                    </>
                  ) : (
                    <>
                      <Save className="w-4 h-4 mr-2" />
                      Registrar Chofer
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        )}

        {/* Tab: Asignar Existente */}
        {activeTab === "asignar" && (
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-12 text-center max-w-2xl mx-auto">
            <UserPlus className="h-16 w-16 text-gray-300 mx-auto mb-4" />
            <h3 className="text-xl font-semibold text-gray-900 mb-2">
              Asignar Conductor Existente
            </h3>
            <p className="text-gray-600 mb-6">
              Busca conductores registrados en otras empresas y asígnalos a tu
              flota
            </p>
            <p className="text-sm text-blue-600 bg-blue-50 p-4 rounded-lg">
              💡 <strong>Próximamente:</strong> Podrás buscar y asignar
              conductores que ya trabajan para otras empresas transportistas.
            </p>
          </div>
        )}
      </div>

      {/* Modal Ver/Editar */}
      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            {/* Header */}
            <div
              className={`px-6 py-4 ${modalMode === "view"
                  ? "bg-gradient-to-r from-purple-500 to-pink-600"
                  : "bg-gradient-to-r from-emerald-500 to-teal-600"
                }`}
            >
              <div className="flex items-center justify-between">
                <h3 className="text-lg font-bold text-white">
                  {modalMode === "view"
                    ? "Detalles del Conductor"
                    : "Editar Conductor"}
                </h3>
                <button
                  onClick={handleCloseModal}
                  className="text-white hover:bg-white/20 p-2 rounded-lg transition-colors"
                >
                  <X className="h-5 w-5" />
                </button>
              </div>
            </div>

            {/* Content */}
            <div className="p-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* DNI */}
                <div>
                  <label htmlFor="edit_dni" className="block text-sm font-medium text-gray-700 mb-1">
                    DNI
                  </label>
                  {modalMode === "view" ? (
                    <p className="text-gray-900 font-medium">{formData.dni}</p>
                  ) : (
                    <>
                      <input
                        id="edit_dni"
                        type="text"
                        name="dni"
                        value={formData.dni || ""}
                        onChange={handleChange}
                        className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-emerald-500 ${errors.dni ? "border-red-500" : "border-gray-300"
                          }`}
                      />
                      {errors.dni && (
                        <p className="text-red-500 text-xs mt-1">
                          {errors.dni[0]}
                        </p>
                      )}
                    </>
                  )}
                </div>

                {/* Nombre */}
                <div>
                  <label htmlFor="edit_nombre" className="block text-sm font-medium text-gray-700 mb-1">
                    Nombre
                  </label>
                  {modalMode === "view" ? (
                    <p className="text-gray-900">{formData.nombre}</p>
                  ) : (
                    <input
                      id="edit_nombre"
                      type="text"
                      name="nombre"
                      value={formData.nombre || ""}
                      onChange={handleChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500"
                    />
                  )}
                </div>

                {/* Apellidos */}
                <div>
                  <label htmlFor="edit_apellidos" className="block text-sm font-medium text-gray-700 mb-1">
                    Apellidos
                  </label>
                  {modalMode === "view" ? (
                    <p className="text-gray-900">{formData.apellidos}</p>
                  ) : (
                    <input
                      id="edit_apellidos"
                      type="text"
                      name="apellidos"
                      value={formData.apellidos || ""}
                      onChange={handleChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500"
                    />
                  )}
                </div>

                {/* Teléfono */}
                <div>
                  <label htmlFor="edit_telefono" className="block text-sm font-medium text-gray-700 mb-1">
                    Teléfono
                  </label>
                  {modalMode === "view" ? (
                    <p className="text-gray-900">{formData.telefono || "-"}</p>
                  ) : (
                    <input
                      id="edit_telefono"
                      type="tel"
                      name="telefono"
                      value={formData.telefono || ""}
                      onChange={handleChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500"
                    />
                  )}
                </div>

                {/* Email */}
                <div className="md:col-span-2">
                  <label htmlFor="edit_email" className="block text-sm font-medium text-gray-700 mb-1">
                    Email
                  </label>
                  {modalMode === "view" ? (
                    <p className="text-gray-900">{formData.email || "-"}</p>
                  ) : (
                    <>
                      <input
                        id="edit_email"
                        type="email"
                        name="email"
                        value={formData.email || ""}
                        onChange={handleChange}
                        className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-emerald-500 ${errors.email ? "border-red-500" : "border-gray-300"
                          }`}
                      />
                      {errors.email && (
                        <p className="text-red-500 text-xs mt-1">
                          {errors.email[0]}
                        </p>
                      )}
                    </>
                  )}
                </div>

                {/* Licencia Número */}
                <div>
                  <label htmlFor="edit_licencia_numero" className="block text-sm font-medium text-gray-700 mb-1">
                    Nº Licencia
                  </label>
                  {modalMode === "view" ? (
                    <p className="text-gray-900">
                      {formData.licencia_numero || "-"}
                    </p>
                  ) : (
                    <input
                      id="edit_licencia_numero"
                      type="text"
                      name="licencia_numero"
                      value={formData.licencia_numero || ""}
                      onChange={handleChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500"
                    />
                  )}
                </div>

                {/* Licencia Categoría */}
                <div>
                  <label htmlFor="edit_licencia_categoria" className="block text-sm font-medium text-gray-700 mb-1">
                    Categoría
                  </label>
                  {modalMode === "view" ? (
                    <p className="text-gray-900">
                      {formData.licencia_categoria}
                    </p>
                  ) : (
                    <select
                      id="edit_licencia_categoria"
                      name="licencia_categoria"
                      value={formData.licencia_categoria || "B-IIc"}
                      onChange={handleChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500"
                    >
                      <option value="A-I">A-I</option>
                      <option value="A-IIa">A-IIa</option>
                      <option value="A-IIb">A-IIb</option>
                      <option value="A-III">A-III</option>
                      <option value="B-I">B-I</option>
                      <option value="B-IIa">B-IIa</option>
                      <option value="B-IIb">B-IIb</option>
                      <option value="B-IIc">B-IIc</option>
                      <option value="B-III">B-III</option>
                    </select>
                  )}
                </div>

                {/* Licencia Vencimiento */}
                <div className="md:col-span-2">
                  <label htmlFor="edit_licencia_vencimiento" className="block text-sm font-medium text-gray-700 mb-1">
                    Vencimiento Licencia
                  </label>
                  {modalMode === "view" ? (
                    <p
                      className={`font-medium ${getLicenciaColor(
                        formData.licencia_vencimiento,
                      )}`}
                    >
                      {formatFecha(formData.licencia_vencimiento)}
                    </p>
                  ) : (
                    <input
                      id="edit_licencia_vencimiento"
                      type="date"
                      name="licencia_vencimiento"
                      value={formatFecha(formData.licencia_vencimiento) || ""}
                      onChange={handleChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500"
                    />
                  )}
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="px-6 py-4 bg-gray-50 border-t border-gray-200 flex justify-end space-x-3">
              <button
                onClick={handleCloseModal}
                className="px-4 py-2 text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 rounded-lg font-medium transition-colors"
              >
                {modalMode === "view" ? "Cerrar" : "Cancelar"}
              </button>
              {modalMode === "edit" && (
                <button
                  onClick={handleSaveEdit}
                  disabled={loading}
                  className="px-6 py-2 text-white bg-gradient-to-r from-emerald-500 to-teal-600 hover:from-emerald-600 hover:to-teal-700 rounded-lg font-medium transition-all duration-200 flex items-center shadow-lg hover:shadow-xl disabled:opacity-50"
                >
                  {loading ? (
                    <>
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                      Guardando...
                    </>
                  ) : (
                    <>
                      <Save className="w-4 h-4 mr-2" />
                      Guardar Cambios
                    </>
                  )}
                </button>
              )}
            </div>
          </div>
        </div>
      )}
      {showAsignarModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-md w-full">
            <div className="bg-gradient-to-r from-orange-500 to-amber-600 px-6 py-4 rounded-t-xl">
              <div className="flex items-center justify-between">
                <h3 className="text-lg font-bold text-white">
                  Asignar Vehículos
                </h3>
                <button
                  onClick={() => setShowAsignarModal(false)}
                  className="text-white hover:bg-white/20 p-2 rounded-lg"
                >
                  <X className="h-5 w-5" />
                </button>
              </div>
              <p className="text-orange-100 text-sm mt-1">
                {selectedConductor?.nombre} {selectedConductor?.apellidos}
              </p>
            </div>

            <div className="p-6 space-y-4">
              {/* Remolcador */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Remolcador
                </label>
                {vehiculos.length > 0 ? (
                  <select
                    value={asignarData.vehiculo_id}
                    onChange={(e) =>
                      setAsignarData((prev) => ({
                        ...prev,
                        vehiculo_id: e.target.value,
                      }))
                    }
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500"
                  >
                    <option value="">Sin asignar</option>
                    {vehiculos.map((v) => (
                      <option key={v.id} value={v.id}>
                        {v.placa}
                      </option>
                    ))}
                  </select>
                ) : (
                  <input
                    type="text"
                    value={asignarData.vehiculo_placa || ""}
                    onChange={(e) =>
                      setAsignarData((prev) => ({
                        ...prev,
                        vehiculo_placa: e.target.value,
                      }))
                    }
                    placeholder="Ingrese placa del remolcador..."
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500"
                  />
                )}
                {vehiculos.length === 0 && (
                  <p className="text-xs text-amber-600 mt-1">
                    ⚠ No hay vehículos cargados — ingrese la placa manualmente
                  </p>
                )}
              </div>
              {/* Semirremolque */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Semirremolque
                </label>
                <div className="flex gap-2">
                  <select
                    value={asignarData.carreta_id}
                    onChange={(e) =>
                      setAsignarData((prev) => ({
                        ...prev,
                        carreta_id: e.target.value,
                      }))
                    }
                    className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500"
                  >
                    <option value="">Sin asignar</option>
                    {carretas.map((c) => (
                      <option key={c.id} value={c.id}>
                        {c.placa}
                      </option>
                    ))}
                  </select>

                  {/* Botón para registrar uno nuevo */}
                  <button
                    type="button"
                    onClick={() => setShowRegistrarCarreta(true)}
                    className="px-3 py-2 text-white bg-emerald-600 hover:bg-emerald-700 rounded-lg text-xs font-medium flex items-center gap-1 whitespace-nowrap"
                    title="Registrar nuevo semirremolque"
                  >
                    <Plus className="h-4 w-4" />
                    Nuevo
                  </button>
                </div>
                {carretas.length === 0 && (
                  <p className="text-xs text-amber-600 mt-1">
                    ⚠ No hay semirremolques registrados. Registra uno nuevo.
                  </p>
                )}
              </div>
            </div>

            <div className="px-6 py-4 bg-gray-50 border-t border-gray-200 flex justify-end space-x-3 rounded-b-xl">
              <button
                onClick={() => setShowAsignarModal(false)}
                className="px-4 py-2 text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 rounded-lg font-medium"
              >
                Cancelar
              </button>
              <button
                onClick={handleGuardarAsignacion}
                disabled={loading}
                className="px-6 py-2 text-white bg-gradient-to-r from-orange-500 to-amber-600 hover:from-orange-600 hover:to-amber-700 rounded-lg font-medium flex items-center disabled:opacity-50"
              >
                {loading ? (
                  <>
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                    Guardando...
                  </>
                ) : (
                  <>
                    <Save className="w-4 h-4 mr-2" />
                    Guardar
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Registrar Nueva Carreta */}
      {showRegistrarCarreta && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black bg-opacity-60 p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-sm w-full">
            <div className="bg-gradient-to-r from-emerald-500 to-teal-600 px-6 py-4 rounded-t-xl">
              <div className="flex items-center justify-between">
                <h3 className="text-lg font-bold text-white">
                  Nuevo Semirremolque
                </h3>
                <button
                  onClick={() => setShowRegistrarCarreta(false)}
                  className="text-white hover:bg-white/20 p-2 rounded-lg"
                >
                  <X className="h-5 w-5" />
                </button>
              </div>
              <p className="text-emerald-100 text-sm mt-1">
                Se registrará y asignará automáticamente
              </p>
            </div>

            <div className="p-6 space-y-3">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Placa <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  value={nuevaCarreta.placa}
                  onChange={(e) =>
                    setNuevaCarreta((prev) => ({
                      ...prev,
                      placa: e.target.value.toUpperCase(),
                    }))
                  }
                  placeholder="Ej: T2K-823"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Marca
                </label>
                <input
                  type="text"
                  value={nuevaCarreta.marca}
                  onChange={(e) =>
                    setNuevaCarreta((prev) => ({
                      ...prev,
                      marca: e.target.value,
                    }))
                  }
                  placeholder="Ej: Schmitz"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Año
                </label>
                <input
                  type="number"
                  value={nuevaCarreta.año}
                  onChange={(e) =>
                    setNuevaCarreta((prev) => ({
                      ...prev,
                      año: e.target.value,
                    }))
                  }
                  placeholder="Ej: 2024"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500"
                />
              </div>
            </div>

            <div className="px-6 py-4 bg-gray-50 border-t border-gray-200 flex justify-end space-x-3 rounded-b-xl">
              <button
                onClick={() => {
                  setShowRegistrarCarreta(false);
                  setNuevaCarreta({ placa: "", marca: "", año: "" });
                }}
                className="px-4 py-2 text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 rounded-lg font-medium"
              >
                Cancelar
              </button>
              <button
                onClick={handleRegistrarCarreta}
                disabled={!nuevaCarreta.placa || loading}
                className="px-4 py-2 text-white bg-gradient-to-r from-emerald-500 to-teal-600 hover:from-emerald-600 hover:to-teal-700 rounded-lg font-medium flex items-center gap-2 disabled:opacity-50"
              >
                {loading ? (
                  <>
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                    Guardando...
                  </>
                ) : (
                  <>
                    <Save className="h-4 w-4" />
                    Registrar y Asignar
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ListarConductores;
